import { Vector4 } from "three";
import FatLineMesh from "../../instancing/Meshes/FatLineMesh";
import LineMesh from "../../instancing/Meshes/LineMesh";
import getMaterialWithUniforms from "../../instancing/materials/getMaterialWithUniforms";

export function getMainLineMesh() {
  const colorMap = Array(20).fill(new Vector4(1, 0, 0.5, 1));
  const conf = {
    posX: 1,
    posY: 1,
    rgbaCode: 1,
  };
  const matconf = { transparent: true, antialias: true };
  const materialConf = getMaterialWithUniforms(matconf)
    .setOffset([0, 0])
    .setWidth(1.5)
    .setColorMap(colorMap);
  return new FatLineMesh(materialConf, conf);
}

export function getLineMesh() {
  const colorMap = Array(20).fill(new Vector4(0, 0.5, 1, 1));
  const conf = {
    posX: 1,
    posY: 1,
    rgbaCode: 1,
  };
  const matconf = { transparent: true, antialias: true };
  const materialConf = getMaterialWithUniforms(matconf)
    .setOffset([0, 0])
    .setColorMap(colorMap);
  return new LineMesh(materialConf, conf);
}

export function drawPoint(lines, mesh) {
  const count = lines.reduce((a, i) => a + i.length, 0);
  const isAppend = true;
  const setX = mesh.updateX({ count, isAppend });
  const setRgb = mesh.updateRgba({ count, isAppend });
  let inc = 0;

  lines.forEach(({ points, sampleInd }) => {
    for (let i = 0; i < points.length - 1; i++) {
      const { region: region1 } = points[i];
      const { region: region2 } = points[i + 1];
      const x1 = region1.g0;
      const x2 = region2.g0;
      setX(inc, x1, x2);
      setRgb(inc, sampleInd, sampleInd, sampleInd, sampleInd);
      inc += 1;
    }
    inc += 1;
  });
}

export function updatePoint(lines, mesh, isLog, activeFilters) {
  const count = lines.reduce((a, i) => a + i.length, 0);
  const setY = mesh.updateY({ count, isAppend: false });
  const hasFilters = activeFilters.size > 0;
  let inc = 0;

  lines.forEach(({ points, analysis }) => {
    const isVisible = !hasFilters || activeFilters.has(analysis);
    if (isVisible && isLog) {
      for (let i = 0; i < points.length - 1; i++) {
        const y1 = points[i].logVal;
        const y2 = points[i + 1].logVal;
        setY(inc, y1, y2);
        inc += 1;
      }
    } else if (isVisible && !isLog) {
      for (let i = 0; i < points.length - 1; i++) {
        const y1 = points[i].val;
        const y2 = points[i + 1].val;
        setY(inc, y1, y2);
        inc += 1;
      }
    } else {
      for (let i = 0; i < points.length - 1; i++) {
        setY(inc, -5000000, -500000);
        inc += 1;
      }
    }
    inc += 1;
  });
}
